import { render, staticRenderFns } from "./img-block.vue?vue&type=template&id=439ad627&scoped=true&"
import script from "./img-block.vue?vue&type=script&lang=js&"
export * from "./img-block.vue?vue&type=script&lang=js&"
import style0 from "./img-block.vue?vue&type=style&index=0&id=439ad627&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439ad627",
  null
  
)

export default component.exports